module.exports = __webpack_public_path__ + "img/profile-pic-explorer.91a9104d.jpg";